import { Grid, Typography } from "@mui/material";

export const BenefitInfo = ({ ibInfo }) => {

  return (
    <Grid container sx={{ padding: "15px" }} gap={1}>
      <Grid item xs={12} md={6}>
        <Typography
          sx={({ breakpoints }) => ({
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "24px",
            color: "#FFFFFF",
            [breakpoints.down("md")]: {
              fontSize: "16px",
            },
          })}
        >
          Beneficio disponible: <span>$ {ibInfo.ibAccumulatedBenefit}</span>
        </Typography>
      </Grid>
    </Grid>
  );
};
